import { Component, ContentChildren, QueryList, AfterContentInit, EventEmitter, Output } from '@angular/core';
import { AccordionItemComponent } from './accordion-item.component';

@Component({
  selector: 'accordion',
  template: `
    <ng-content></ng-content>
  `,
  host: {
    class: 'accordion'
  }
})
export class AccordionComponent implements AfterContentInit {
  @ContentChildren(AccordionItemComponent)
  groups: QueryList<AccordionItemComponent>;

  @Output() onOpen = new EventEmitter<boolean>();

  ngAfterContentInit() {
    this.groups.toArray()[0].opened = true;
    this.groups.toArray().forEach((t) => {
      t.toggle.subscribe(() => {
        this.openGroup(t);
      });
    });
  }

  /**
   * Open an accordion group
   */
  openGroup(group: AccordionItemComponent) {
    if (group.opened) {
      this.groups.toArray().forEach((t) => t.opened = false);
    } else {
      this.groups.toArray().forEach((t) => t.opened = false);
      group.opened = true;
      this.onOpen.emit();
    }
  }

  public closeAll():void {
    this.groups.toArray().forEach((t) => t.opened = false);
  }
}
